import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.css']
})
export class MainFooterComponent implements OnInit {



  lang: string = this.cookie_s.get('lang') || 'en';






  constructor(
    private cookie_s: CookieService
  ) { }

  ngOnInit(): void {
  }




  call()
  {
    window.open('tel: 00201141087755' , '_self')
  }

  whatsapp_chat()
  {
    window.open('https://wa.me/201141087755' , '_blank')
  }

  email()
  {
    window.open('mailto: hossamxp33@gmail.com' , '_self')
  }

  email_2()
  {
    window.open('mailto: info@CodesRoots.com' , '_self')
  }



}
